import Configuration from "./Configuration";
import { getQueryConfiguration } from "../utils";
import Main from "./Main";
import NoApplication from "./Dashboard/NoApplication";

const App = () => {
    const { applicationId } = getQueryConfiguration();

    if (applicationId) {
        return (
            <Configuration>
                <Main />
            </Configuration>
        );
    } else {
        return (
            <Configuration>
                <NoApplication />
            </Configuration>
        );
    }
};

export default App;
